// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TCUDeviceDetails_modalBody__x153V {
    padding: 20px 24px;
    min-height: 200px;
    background: #fff;
}

.TCUDeviceDetails_vehicleHeader__qUeoV {
    padding: 14px 18px;
    margin-bottom: 20px;
    border-radius: 6px;
    background: #f5f8fb;
    border-left: 4px solid var(--primary-blue-theme-color);
}

.TCUDeviceDetails_vehicleLabel__LwwQw {
    font-size: 12px;
    color: #6c757d;
    margin-bottom: 3px;
}

.TCUDeviceDetails_vehicleReg__4Nngc {
    font-size: 20px;
    font-weight: 700;
    color: #343a40;
}

.TCUDeviceDetails_section__oKb6u {
    margin-bottom: 22px;
    padding: 16px 18px;
    border: 1px solid #dee2e6;
    border-radius: 7px;
}

.TCUDeviceDetails_sectionTitle__whP80 {
    margin-bottom: 18px;
    padding-left: 10px;
    border-left: 4px solid var(--primary-blue-theme-color);
    color: #4f7cac;
    font-size: 15px;
    font-weight: 700;
}

.TCUDeviceDetails_infoLabel__FVuhw {
    margin-bottom: 5px;
    color: #6c757d;
    font-size: 12px;
}

.TCUDeviceDetails_infoValue__d9mhs {
    color: #212529;
    font-size: 14px;
    font-weight: 600;
}

.TCUDeviceDetails_statusBadge__JwBHp {
    display: inline-block;
    padding: 5px 14px;
    border-radius: 20px;
    background: #f8d7da;
    color: #842029;
    font-size: 12px;
    font-weight: 600;
}

.TCUDeviceDetails_lastInfo__dNxbm {
    padding: 12px 14px;
    border-radius: 5px;
    background: #f8f9fa;
    color: #495057;
    font-size: 13px;
    font-weight: 500;
}

.TCUDeviceDetails_actionContainer__IgQYv {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #dee2e6;
}

.TCUDeviceDetails_closeButton__k5rMV,
.TCUDeviceDetails_exportButton__tbKNc {
    border: none;
    border-radius: 5px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}

.TCUDeviceDetails_closeButton__k5rMV {
    background: #6c757d;
    color: #fff;
}

.TCUDeviceDetails_exportButton__tbKNc {
    background: #4f7cac;
    color: #fff;
}

.TCUDeviceDetails_exportButton__tbKNc:hover {
    background: #3f6790;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/LostTCUTable/TCUDeviceDetails.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sDAAsD;IACtD,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".modalBody {\n    padding: 20px 24px;\n    min-height: 200px;\n    background: #fff;\n}\n\n.vehicleHeader {\n    padding: 14px 18px;\n    margin-bottom: 20px;\n    border-radius: 6px;\n    background: #f5f8fb;\n    border-left: 4px solid var(--primary-blue-theme-color);\n}\n\n.vehicleLabel {\n    font-size: 12px;\n    color: #6c757d;\n    margin-bottom: 3px;\n}\n\n.vehicleReg {\n    font-size: 20px;\n    font-weight: 700;\n    color: #343a40;\n}\n\n.section {\n    margin-bottom: 22px;\n    padding: 16px 18px;\n    border: 1px solid #dee2e6;\n    border-radius: 7px;\n}\n\n.sectionTitle {\n    margin-bottom: 18px;\n    padding-left: 10px;\n    border-left: 4px solid var(--primary-blue-theme-color);\n    color: #4f7cac;\n    font-size: 15px;\n    font-weight: 700;\n}\n\n.infoLabel {\n    margin-bottom: 5px;\n    color: #6c757d;\n    font-size: 12px;\n}\n\n.infoValue {\n    color: #212529;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.statusBadge {\n    display: inline-block;\n    padding: 5px 14px;\n    border-radius: 20px;\n    background: #f8d7da;\n    color: #842029;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.lastInfo {\n    padding: 12px 14px;\n    border-radius: 5px;\n    background: #f8f9fa;\n    color: #495057;\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.actionContainer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 20px;\n    padding-top: 15px;\n    border-top: 1px solid #dee2e6;\n}\n\n.closeButton,\n.exportButton {\n    border: none;\n    border-radius: 5px;\n    padding: 8px 16px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.closeButton {\n    background: #6c757d;\n    color: #fff;\n}\n\n.exportButton {\n    background: #4f7cac;\n    color: #fff;\n}\n\n.exportButton:hover {\n    background: #3f6790;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBody": `TCUDeviceDetails_modalBody__x153V`,
	"vehicleHeader": `TCUDeviceDetails_vehicleHeader__qUeoV`,
	"vehicleLabel": `TCUDeviceDetails_vehicleLabel__LwwQw`,
	"vehicleReg": `TCUDeviceDetails_vehicleReg__4Nngc`,
	"section": `TCUDeviceDetails_section__oKb6u`,
	"sectionTitle": `TCUDeviceDetails_sectionTitle__whP80`,
	"infoLabel": `TCUDeviceDetails_infoLabel__FVuhw`,
	"infoValue": `TCUDeviceDetails_infoValue__d9mhs`,
	"statusBadge": `TCUDeviceDetails_statusBadge__JwBHp`,
	"lastInfo": `TCUDeviceDetails_lastInfo__dNxbm`,
	"actionContainer": `TCUDeviceDetails_actionContainer__IgQYv`,
	"closeButton": `TCUDeviceDetails_closeButton__k5rMV`,
	"exportButton": `TCUDeviceDetails_exportButton__tbKNc`
};
export default ___CSS_LOADER_EXPORT___;
